import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, input, OnDestroy, OnInit, inject } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-valuation-status-bar',
    template: `
    <div class="progress-container">
      <div class="progress-bar" [style.width.%]="value()" [style.background-color]="getColor()">
      </div>
      @if(!isMobile) {
        <div class="black-divider" style="left: 20%"></div>
        <div class="black-divider" style="left: 40%"></div>
        <div class="black-divider" style="left: 66%"></div>
      }
    </div>
  `,
    styles: [`
    .progress-container {
      height: 25px;
      position: relative;
      background-color: #e5e7eb;
      border-radius: 4px;
      overflow: hidden;
    }

    .progress-bar {
      height: 100%;
      min-width: 2px;
      transition: width 0.3s ease, background-color 0.3s ease;
    }

    .black-divider {
      position: absolute;
      top: 0;
      width: 2px;
      height: 100%;
      background-color: #b1b1b1;
    }
  `],
})
export class ValuationStatusBarComponent implements OnInit, OnDestroy {
  private readonly breakpointObserver = inject(BreakpointObserver);

  readonly destroy$ = new Subject<void>();
  value = input<number>(0);
  isMobile = false;

  ngOnInit(): void {
    this.breakpointObserver.observe([
      Breakpoints.HandsetPortrait,
      Breakpoints.HandsetLandscape,
      Breakpoints.TabletPortrait,
    ])
      .pipe(takeUntil(this.destroy$))
      .subscribe((result) => {
        this.isMobile = result.matches;
      });
  }

  getColor(): string {
    if (this.value() <= 20) {
      return '#fc0200';
    }
    if (this.value() <= 40) {
      return '#ffc002';
    }
    return '#92d052';
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
